// extracted by mini-css-extract-plugin
module.exports = {"InputLabel":"style_InputLabel__3-sQo","description":"style_description__2ACdk","mark":"style_mark__3igoK","height":"style_height__1ejZf"};